import colors from '@styles/common/colors';
import styled from 'styled-components';

export const BorderLine = styled.div`
  width: 100%;
  border: 0.1px solid ${colors.secondary_color.variant_two};
`;
